module.exports = __webpack_public_path__ + "img/map.1cab8640.svg";